export const errorsContain = (errorCodes, code) => {
  return errorCodes?.some(c => {
    const regex = new RegExp(code, 'i')
    return regex.test(c)
  })
}

export const objectIdIsEmpty = id => {
  return !id || id === '000000000000000000000000'
}

export const hasSomeAccess = permissions => {
  if (!permissions) return false
  const keys = Object.keys(permissions)
  for (const key of keys) {
    if (typeof permissions[key] === 'boolean') {
      if (permissions[key]) return true
    }

    // This is an object... recurse
    if (hasSomeAccess(permissions[key])) return true
  }
  return false
}

export const slugify = text => {
  if (!text) return ''
  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/[^\w-]+/g, '') // Remove all non-word chars
    .replace(/--+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, '') // Trim - from end of text
}
